export function $Jsonp(obj) {
  var cbName = "cb" + new Date().getTime();

  window[cbName] = function (object) {
    if (typeof object == "string") {
      obj.success(JSON.parse(object));
    } else {
      obj.success(object);
    }
  };

  var script = document.createElement("script"); //组合请求URL

  script.src = obj.url + "&callback=" + cbName;

  for (var key in obj.data) {
    script.src += "&" + key + "=" + obj.data[key];
  } //将创建的新节点添加到BOM树上


  document.getElementsByTagName("body")[0].appendChild(script);
}